import { useEmployeeTasksPermissions } from "employee_tasks/hooks/useTasks";

export const useCanCreate = (employeeId: number) => {
  const { data } = useEmployeeTasksPermissions(employeeId);
  return data?.["employee_tasks.can_create_tasks"] || false;
};

export const useCanView = (employeeId: number) => {
  const { data } = useEmployeeTasksPermissions(employeeId);
  return data?.["employee_tasks.can_view_tasks"] || false;
};

export const useCanEvaluate = (employeeId: number) => {
  const { data } = useEmployeeTasksPermissions(employeeId);
  return data?.["employee_tasks.can_evaluate_task"] || false;
};

export const useCanViewEvaluations = (employeeId: number) => {
  const { data } = useEmployeeTasksPermissions(employeeId);
  return data?.["employee_tasks.can_view_evaluations"] || false;
};

export const useCanEdit = (employeeId: number) => {
  const { data } = useEmployeeTasksPermissions(employeeId);
  return data?.["employee_tasks.can_edit_task"] || false;
};

export const useCanEditTemplate = (employeeId: number) => {
  const { data } = useEmployeeTasksPermissions(employeeId);
  return data?.["employee_tasks.can_edit_template_task"] || false;
};

export const useCanDelete = (employeeId: number) => {
  const { data } = useEmployeeTasksPermissions(employeeId);
  return data?.["employee_tasks.can_delete_task"] || false;
};
